export default __webpack_public_path__ + "static/media/ofs_700.16b87f08.jpg";